import React from 'react';
import { useDispatch } from 'react-redux';
import { Notification } from '@vds/notifications';

const NotificationComponent = ({ show, type, message, onCloseAction, useStyles }) => {
    const dispatch = useDispatch();

    const disableGlobalErrorMessage = (data) => {
        dispatch(onCloseAction({ enableNotification: data}))
    }

    return (
            <div>
            {show ? <div className="global-notification" style={{ position: 'relative', ...useStyles }}> <Notification type={type} onCloseButtonClick={() => disableGlobalErrorMessage(false)}><p>{message}</p></Notification> </div>: ''}
            </div>);
}

export default NotificationComponent;